export const pushHistory = ({
  history,
  path,
  includeQuery = true,
}) => {
  history.push(path + (includeQuery ? history.location.search : ''));
};
